const languagePack = Object.assign(
  {},
  require('./account.json'),
  require('./advisory.json'),
  require('./allocation.json'),
  require('./analyse.json'),
  require('./api-values.json'),
  require('./arbitration.json'),
  require('./club.json'),
  require('./common.json'),
  require('./contract.json'),
  require('./dashboard.json'),
  require('./fund.json'),
  require('./interaction.json'),
  require('./loan.json'),
  require('./mission.json'),
  require('./project.json'),
  require('./real-estate.json'),
  require('./subscription.json'),
  require('./toast.json'),
  require('./user.json'),
  require('./devices.json'),
  require('./cgu.json'),
  require('../brandnames.json')
)

module.exports = languagePack
